<template>
  <div class="row">
    <!-- <div style="margin-left: -100px; margin-top: 250px; position: absolute">
      <div
        class="right-button"
        v-if="this.scroll == true"
        v-on:click="getScroll2()"
      >
        <p style="font-size: 50px">&lt;</p>
      </div>
    </div>

    <div style="right: -100px; margin-top: 250px; position: absolute">
      <div
        class="right-button"
        v-if="this.scroll == false"
        v-on:click="getScroll()"
      >
        <p style="font-size: 50px">&gt;</p>
      </div>
    </div> -->

    <div class="col-lg-12">
      <StatusModal
        :show.sync="modals.successModal"
        :message="modal.success"
        :title="modal.successTitle"
      />

      <div class="row">
        <div class="col-lg">
          <div class="scrollable-row">
            <div class="col-lg-4 d-flex">
              <card class="card-eprf">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  JOB DETAILS
                </p>
                <div
                  style="height: 520px; overflow: scroll; overflow-x: hidden"
                >
                  <p class="new-title">Job Reference No.</p>
                  <p class="subtitle">{{ jobno }}</p>

                  <p class="new-title" v-if="landvesselflag == 'LAND'">
                    Collection Date
                  </p>
                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Arrival ETA
                  </p>
                  <p class="subtitle">{{ arrivalETA }}</p>

                  <p class="new-title" >
                    Service Location
                  </p>
                  <p class="subtitle" >
                    {{ servicelocation }}
                  </p>

                  <p class="new-title" >
                    Service Location Collection
                  </p>
                  <p class="subtitle" >
                    {{ servicelocationcollection }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Departure (ETD)
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ departureETD }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Previous Port
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ previousPort }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Next Port
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ nextPort }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Last Port When Generated Waste Delivered
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ lastPortAndDate }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Last Date When Generated Waste Delivered
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ lastDate }}
                  </p>

                  <p class="new-title">Company Name</p>
                  <p class="subtitle">{{ companyName }}</p>

                  <p class="new-title">Company Address</p>
                  <p class="subtitle">{{ companyAddress }}</p>

                  <p class="new-title">Phone No. / Fax No.</p>
                  <p class="subtitle">{{ phoneNoFaxNo }}</p>

                  <p class="new-title">PIC Full Name</p>
                  <p class="subtitle">{{ picFullName }}</p>

                  <p class="new-title">PIC Phone No. / Fax No.</p>
                  <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

                  <p class="new-title">PIC Email</p>
                  <p class="subtitle">{{ picEmail }}</p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Ship Name
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ shipName }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    IMO No.
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ imoNo }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Ship Type
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ shipType }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Gross Tonnage
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ grossTonnage }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Deadweight Tonnage (kg)
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ deadweightTonnage }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Owner / Operator Name
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ owneroperatorname }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Call Sign
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ callSign }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Flag State
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ flagState }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Sustainable Certificates
                  </p>
                  <div v-if="landvesselflag == 'VESSEL' && shipdoc.length !== 0" v-for="(file, index) in shipdoc"
                :key="'allship_file' + index" class="row">
                <div class="col-lg-8">
                  {{ index + 1 }}.
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
              </div>
              <p v-if="landvesselflag == 'VESSEL' && shipdoc.length === 0" class="subtitle">
                None
              </p>
                </div>
              </card>
            </div>
            <div v-if="generate == true" class="col-lg-4 d-flex">
              <card class="card-eprf">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  PERMIT TO WORK (PTW) 
                </p>

                <p style="" v-if="positionid != 4" class="newtitle">Choose File from Your Desktop</p>
                <p class="sub-titles" v-if="positionid != 4">
                  Please upload any existing contract for recurring job request
                </p>
                <div class="fileinput" v-if="positionid != 4">
                  <label
                    for="ptw-upload"
                    type="primary"
                    class="btn"
                    style="
                      font-size: 13px;
                      color: #ffffff;
                      text-transform: capitalize;
                    "
                  >
                    <span>Choose File</span>
                  </label>
                  <div
                    class="d-flex justify-content-center spinner"
                    v-if="this.uploadloadPTW == true"
                  >
                    <circle-8></circle-8>
                  </div>

                  <input
                    accept="application/pdf"
                    id="ptw-upload"
                    ref="ptwfile"
                    type="file"
                    name="..."
                    class="valid"
                    :multiple="true"
                    aria-invalid="false"
                    style="display: none"
                    v-on:change="onFileChangePTW"
                  />
                </div>
                <!-- v-if="this.uploadloadPTW == false" -->
                <div
                  style="
                    height: 150px;
                    padding: 0px 20px 20px 0px;
                    margin: 0px 30px 20px 0px;
                  "
                  class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
                >
                  <div
                    v-for="(filee, index) in allfilePTWname"
                    :key="index"
                    class="row"
                  >
                    <div class="col-lg-8">
                      <a :href="filee.fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ filee.filename }}
                        </base-button>
                      </a>
                      <!-- <p
                        style="padding-left: 15px; color: #A5A5A5"
                        id="file-namee"
                      >
                        
                      </p> -->
                    </div>
                    <div class="col-lg-4" v-if="positionid != 4">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeFile(filee.fileid)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>

                <!-- <p style="margin-top: 50px" class="newtitle">
              View Your Generated PTW
            </p>
            <base-button type="primary" v-on:click="getLogin()"
              >View</base-button
            > -->
              </card>
            </div>
            <div class="col-lg-4" v-if="generate == 'false'">
              <card
                style="
                  box-shadow: none;
                  padding: 0px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                "
              >
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  PERMIT TO WORK (PTW)
                </p>
                <p class="new-title">PTW No.</p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="ptwno"
                    :class="{ 'custom-input': true }"
                  />
                </div>
                <!-- <p class="sub-title">12089</p> -->

                <p class="new-title">Transporter</p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="transporter"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p class="new-title">DOE No.</p>
                <p class="subtitle">EIA TA/13</p>

                <p class="new-title">Company Address</p>
                <p class="subtitle">
                  Lot 42, Jalan Suria 5, Kajang, 43000 Selangor, Malaysia
                </p>

                <p class="new-title">Phone No. / Fax No.</p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="phoneno"
                    :class="{ 'custom-input': true }"
                  />
                </div>
                <!-- <p class="sub-title">+60345625454</p> -->
              </card>
            </div>
            <div class="col-lg-8" v-if="generate == 'false'">
              <card class="card-eprf">
                <div class="row">
                  <div class="col-lg">
                    <p
                      style="color: #358CCB; font-size: 24px; font-weight: 300"
                    >
                      WASTE DETAILS
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <!--   :cell-class-name="evenclass" -->
                    <el-table
                      :data="wastedetails"
                      :header-cell-style="{
                        background: '#358DCC',
                        border: 'transparent',
                        'font-size': '14px',
                        'font-weight': '400',
                        color: '#FFFFFF',
                      }"
                      :cell-style="{ fontColor: '#707070' }"
                      :row-style="tableRowClassName"
                      style="color: #707070"
                    >
                      <el-table-column label="No." width="50" align="center">
                        <div slot-scope="scope">
                          <p style="color: #707070">{{ scope.$index + 1 }}</p>
                        </div>
                      </el-table-column>

                      <el-table-column
                        label="Waste Type"
                        prop="wastetype"
                        width="160"
                      ></el-table-column>
                      <el-table-column
                        label="Waste Qty."
                        prop="wasteqty"
                      ></el-table-column>
                      <el-table-column
                        label="Max Dedicated Storage Capacity"
                        prop="maxdedicatedstoragecapacity"
                        width="170"
                      ></el-table-column>
                      <el-table-column
                        label="Waste Amount Retained On-board"
                        prop="wasteamountretainedonboard"
                        width="170"
                      ></el-table-column>
                      <el-table-column
                        label="Remarks"
                        prop="remarks"
                      ></el-table-column>
                    </el-table>
                  </div>
                </div>
              </card>
            </div>
            <!-- <div class="col-lg-4">
          <card
            style="box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              WASTE TO BE COLLECTED
            </p>
            <p class="new-title">Waste Type</p>
            <p class="subtitle">Annex I - Oily bilge water</p>

            <p class="new-title">Waste Quantity</p>
            <p class="subtitle">300 MT</p>

            <p class="new-title">Max Dedicated Storage Capacity</p>
            <p class="subtitle">500 MT</p>

            <p class="new-title">Amount of Waste Retained Onboard</p>
            <p class="subtitle">50 MT</p>
          </card>
        </div>
   
        <div class="col-lg-4">
          <card
            style="box-shadow: none;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              CUSTOMER DETAILS
            </p>
            <p class="new-title">Customer Name</p>
            <p class="subtitle">Ombak Biru Holdings</p>

            <p class="new-title">Ship Name</p>
            <p class="subtitle">Eagle 01</p>

            <p class="new-title">PIC Full Name</p>
            <p class="subtitle">Amirah binti Azman</p>

            <p class="new-title">PIC Phone No. / Fax No.</p>
            <p class="subtitle">+60195627890</p>

            <p class="new-title">PIC Email</p>
            <p class="subtitle">amirah@ombakb.com.my</p>
          </card>
        </div> -->
            <div class="col-lg-4" v-if="generate == 'false'">
              <card
                style="
                  box-shadow: none;
                  padding: 0px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                "
              >
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  TRANSPORTER DETAILS
                </p>
                <p class="new-title">Transporter Name</p>
                <p class="subtitle">Berjaya Waste Sdn Bhd</p>

                <p class="new-title">PIC Full Name</p>
                <p class="subtitle">Nick Chan</p>

                <p class="new-title">Phone No. / Fax No.</p>
                <p class="subtitle">+60129923290</p>

                <p class="new-title">Vehicle Registration No.</p>
                <p class="subtitle">BGK 8080</p>
              </card>
            </div>
            <div class="col-lg-4" v-if="generate == 'false'">
              <card
                style="
                  box-shadow: none;
                  color: #A5A5A5;
                  padding: 0px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                "
              >
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  CHECKLIST
                </p>
                <p class="new-title">Facility Type</p>
                <input
                  type="checkbox"
                  class="rounded-checkbox"
                  id="checkbox"
                  v-model="checkedItems"
                  :value="selectall[0].value"
                />&nbsp;&nbsp;{{ selectall[0].label }}
                <div
                  style="
                    padding-top: 10px;
                    margin-bottom: 5px;
                    width: 80%;
                    border-bottom: 1px solid lightgray;
                  "
                ></div>
                <div>
                  <div
                    style="line-height: 0.7cm"
                    v-for="(file, index) in facilitytypes"
                    :key="index"
                  >
                    <input
                      type="checkbox"
                      class="rounded-checkbox"
                      id="checkbox"
                      v-model="checkedItems"
                      :value="facilitytypes[index].value"
                    />&nbsp;&nbsp;{{ facilitytypes[index].label }}
                  </div>
                  <div v-if="checkedItems.includes(14)">
                    <div style="padding-right: 30px">
                      <input
                        type="text"
                        v-model="specifies"
                        :class="{ 'custom-input': true }"
                      />
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button
            wide
            type="danger"
            @click.native="prevTab"
            class="btn-previous"
          >
            BACK
          </base-button>
          <base-button
            type="primary"
            wide
            @click.native="nextTab"
            class="btn-next"
            :disabled="disablebtn"
          >
            NEXT
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import moment from "moment";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";
// import { position } from "html2canvas/dist/types/css/property-descriptors/position";

export default {
  props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Circle8,
    Modal,
  },
  props: ["test1"],
  data() {
    return {
      modal: modal,
      disablebtn: true,
      allfilePTWname: [],
      allfileTPTWname: [],
      servicelocation: "",
      servicelocationcollection: "",
      modals: {
        successModal: false,
      },
      message: "",
      jobno: "",
      arrivalETA: "18 Nov 2022",
      departureETD: "15 Nov 2022",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      lastDate: "",
      companyName: "Ombak Biru Holdings",
      companyAddress: "Coplace 2, Switzeeerrrrrss",
      phoneNoFaxNo: "08-98989989",
      picFullName: "Wahab bin Wahab",
      picPhoneNoFaxNo: "012-3569488",
      picEmail: "wahab@sendirianberhad.com",
      shipName: "Tiger Wave",
      imoNo: "8804275",
      shipType: "Ikan bilis tanker",
      grossTonnage: "220000",
      deadweightTonnage: "10000",
      owneroperatorname: "Abu bin Seman",
      callSign: "Bilis dot com",
      flagState: "Malaysia",
      sustainableCertificates: "1 - ISO 14001.pdf",
      shipdoc: [],

      wastedetails: [
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
      ],

      generate: true,
      selectedFileNamePTW: "",
      allfilenamePTW: [],
      docsPTW: "",
      documentPTW: 0,
      documentIDPTW: [],
      uploadloadPTW: false,
      uploadterminatedPTW: false,
      scroll: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      checkedItems: [],

      selectall: [{ value: 0, label: "Select all" }],

      facilitytypes: [
        { value: 1, label: "Terminal approval" },
        { value: 2, label: "Safety helmet" },
        { value: 3, label: "Life jacket" },
        { value: 4, label: "Hand glove" },
        { value: 5, label: "Safety shoes" },
        { value: 6, label: "Safety vase" },
        { value: 7, label: "Fire extinguisher" },
        { value: 8, label: "Oil boom" },
        { value: 9, label: "Signage" },
        { value: 10, label: "Lorry choke" },
        { value: 11, label: "Oil dip tray" },
        { value: 12, label: "Bariccade" },
        { value: 13, label: "SOPEP equipment" },
        { value: 14, label: "Other (specify):" },
      ],

      specifies: "",

      ptwno: "12089",
      transporter: "Transporter A",
      deliveryterm: "",
      paymentterm: "",
      phoneno: "+60345625454",

      selects: {
        date: "",

        transporter: "",
        transporters: [
          { value: "1", label: "Ikhlas Waste Sdn Bhd" },
          { value: "2", label: "Berjaya Waste Sdn Bhd" },
          { value: "3", label: "Gemilang Waste Holdings" },
        ],
      },
      landvesselflag: "",
      positionid: "",
    };
  },
  created() {
    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getDetail();

    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
  },
  mounted() {},
  methods: {
    getDetail() {
      this.allfilePTWname = [];
      this.shipdoc = [];

      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          if (response.allow_upload_wdr_wdo) {
            this.disablebtn = false;
          } else {
            this.disablebtn = true;
          }

          this.landvesselflag = response.company.company_type.toUpperCase();

          this.arrivalETA = moment(response.arrival_eta).format("DD MMM YYYY");
          this.departureETD = moment(response.departure_eta).format(
            "DD MMM YYYY"
          );

          this.servicelocation = response.service_location_name;
          this.servicelocationcollection =
            response.service_location_collection_name;

          this.previousPort =
            response.previous_port == "" ? "None" : response.previous_port;
          this.nextPort =
            response.next_port == "" ? "None" : response.next_port;
          this.lastPortAndDate =
            response.last_port == "" ? "None" : response.last_port;
          this.lastDate =
            response.last_port_date == "" ? "N/A" : moment(response.last_port_date).format(
            "DD MMM YYYY"
          );

          this.companyName = response.company.company_name;
          this.companyAddress = response.company.company_address;
          this.phoneNoFaxNo =
            (response.company.company_phone_number == "" ||
            response.company.company_phone_number == null
              ? "N/A"
              : response.company.company_phone_number) +
            " / " +
            (response.company.company_fax_number == "" ||
            response.company.company_fax_number == null
              ? "N/A"
              : response.company.company_fax_number);
          this.picFullName = response.pic.user_name;
          this.picPhoneNoFaxNo =
            (response.pic.pic_phone_number == "" ||
            response.pic.pic_phone_number == null
              ? "N/A"
              : response.pic.pic_phone_number) +
            " / " +
            (response.pic.pic_fax_number == "" ||
            response.pic.pic_fax_number == null
              ? "N/A"
              : response.pic.pic_fax_number);
          this.picEmail = response.pic.user_email;
          this.shipName = response.ship.ship_name;
          this.imoNo = response.ship.imo_number;
          this.shipType = response.ship.ship_type_name;
          this.grossTonnage = response.ship.gross_tonnage;
          this.deadweightTonnage = response.ship.deadweight_tonnage;
          this.owneroperatorname = response.ship.operator_name;
          this.callSign = response.ship.call_sign;
          this.flagState = response.ship.country_name;
          // this.sustainableCertificates =
            // response.ship.documents == null ? "None" : response.ship.documents;

            if (response.ship.documents != null) {
            for (var i = 0; i < response.ship.documents.length; i++) {
              let obj = {
                filename: response.ship.documents[i].meta.filename,
                fileid: response.ship.documents[i].ship_document_id,
                fileurl: response.ship.documents[i].url,
              };
              this.shipdoc.push(obj);
            }
          }

          // get all ptw
          if (response.ptw != null) {
            for (var i = 0; i < response.ptw.length; i++) {
              let obj = {
                filename: response.ptw[i].meta.filename,
                fileurl: response.ptw[i].url,
                fileid: response.ptw[i].ptw_support_document_id,
              };
              this.allfilePTWname.push(obj);
            }
          }
        }
      });
    },
    nextTab() {
      let parameter = {
        step: "3",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    prevTab() {
      let parameter = {
        step: "3",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    onFileChangePTW(event) {
      console.log("___________ hoy_________________");
      if (this.allfilePTWname.length == 0) {
        this.docsPTW = this.$refs.ptwfile.files[0];

        this.selectedFileNamePTW = this.$refs.ptwfile.files[0].name;
        this.allfilenamePTW.push(this.selectedFileNamePTW);

        const formData = new FormData();
        formData.append("document", this.docsPTW);

        // to verify form data
        for (var pair of formData.entries()) {
          console.log(pair);
        }

        this.uploadloadPTW = true;

        this.$http
          .post(
            ":10001/api/v1/incoming/" + this.jobno + "/ptw/upload-ptw",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              this.message = response;
              this.modals.successModal = true;
              // swal({
              //   title: `Success!`,
              //   text: response,
              //   buttonsStyling: false,
              //   confirmButtonClass: "btn btn-primary btn-fill",
              //   type: "success",
              // });
              this.getDetail();
              this.uploadloadPTW = false;
            }
          });
      } else {
        swal({
          title: `Info!`,
          text: "Only 1 file allowed to be uploaded",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "info",
        });
      }
    },
    onFileChangeTPTW(event) {
      
      if (this.allfileTPTWname.length == 0) {
        this.docsPTW = this.$refs.terminatedptwfile.files[0];

        this.selectedFileNamePTW = this.$refs.ptwfile.files[0].name;
        this.allfilenamePTW.push(this.selectedFileNamePTW);

        const formData = new FormData();
        formData.append("document", this.docsPTW);

        // to verify form data
        for (var pair of formData.entries()) {
          console.log(pair);
        }

        this.uploadloadTPTW = true;

        this.$http
          .post(
            ":10001/api/v1/incoming/" + this.jobno + "/ptw/upload-ptw",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              this.message = response;
              this.modals.successModal = true;
              // swal({
              //   title: `Success!`,
              //   text: response,
              //   buttonsStyling: false,
              //   confirmButtonClass: "btn btn-primary btn-fill",
              //   type: "success",
              // });
              this.getDetail();
              this.uploadloadPTW = false;
            }
          });
      } else {
        swal({
          title: `Info!`,
          text: "Only 1 file allowed to be uploaded",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "info",
        });
      }
    },
    removePTWFile(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        // if (result.value == true) {
        //   this.$http
        //     .delete(":10001/api/v1/incoming/" + this.jobno + "/ptw/" + fileid)
        //     .then((res) => {
        //       if (!res.error) {
        //         let response = res.message;
        //         console.log(response);
        //         swal({
        //           title: `Success!`,
        //           text: response,
        //           buttonsStyling: false,
        //           confirmButtonClass: "btn btn-primary btn-fill",
        //           type: "success",
        //         });
        //         this.getDetail();
        //       }
        //     });
        // }
      });
    },
    removeFile(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/incoming/" + this.jobno + "/ptw/" + fileid)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                swal({
                  title: `Success!`,
                  text: response,
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                });
                this.getDetail();
              }
            });
        }
      });
    },
    getScroll() {
      this.scroll = true;
    },
    getScroll2() {
      this.scroll = false;
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
  watch: {
    // allfilePTWname: {
    //   handler: function (val, oldVal) {
    //     if (this.allfilePTWname.length != 0) {
    //       this.disablebtn = false;
    //     } else {
    //       this.disablebtn = true;
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  text-decoration: underline;
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-titles {
  margin-top: -5px;
  color: #A5A5A5;
}

/* Styles for individual buttons */
.left-button,
.right-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #358CCB; /* You can change the color as desired */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px; /* Adjust as needed */
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
